import React, { SVGProps } from "react";

export default function SupSuperSmarts(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6707 11.7404C14.8301 10.7211 15.5619 9.22694 15.5619 7.56181C15.5619 4.49011 13.0717 2 10 2C6.92834 2 4.43823 4.49011 4.43823 7.56181C4.43823 9.22694 5.16996 10.7211 6.32941 11.7404C6.51702 11.9054 6.71583 12.0579 6.92455 12.1967C7.02371 12.2626 7.1251 12.3254 7.22859 12.385C7.28699 12.9638 7.61157 13.4639 8.07804 13.7612C8.36552 13.9444 8.7069 14.0506 9.07308 14.0506H10.927C11.2932 14.0506 11.6346 13.9444 11.922 13.7612C12.3885 13.4639 12.7131 12.9638 12.7715 12.385C12.875 12.3254 12.9764 12.2626 13.0755 12.1967C13.2843 12.0579 13.4831 11.9054 13.6707 11.7404ZM13.3262 10.7896C14.1362 9.95505 14.6349 8.81667 14.6349 7.56181C14.6349 5.00206 12.5598 2.92697 10 2.92697C7.44029 2.92697 5.3652 5.00206 5.3652 7.56181C5.3652 8.81667 5.86389 9.95505 6.6739 10.7896C7.10828 11.2371 7.63218 11.5973 8.21673 11.8412C8.76567 12.0702 9.36809 12.1967 10 12.1967C10.632 12.1967 11.2344 12.0702 11.7834 11.8412C12.3679 11.5973 12.8918 11.2371 13.3262 10.7896Z"
        fill="currentColor"
      />
      <path
        d="M8.17427 15.763C8.12982 15.5109 8.29815 15.2705 8.55023 15.2261L11.2889 14.7432C11.541 14.6987 11.7814 14.867 11.8258 15.1191C11.8703 15.3712 11.7019 15.6116 11.4499 15.656L8.7112 16.1389C8.45911 16.1834 8.21872 16.0151 8.17427 15.763Z"
        fill="currentColor"
      />
      <path
        d="M8.17427 17.6169C8.12982 17.3648 8.29815 17.1244 8.55023 17.08L11.2889 16.5971C11.541 16.5526 11.7814 16.721 11.8258 16.9731C11.8703 17.2251 11.7019 17.4655 11.4499 17.51L8.7112 17.9929C8.45911 18.0373 8.21872 17.869 8.17427 17.6169Z"
        fill="currentColor"
      />
    </svg>
  );
}
